import { Controller } from 'stimulus';
import { toggleClass } from '../utilities';

export default class extends Controller {
  connect() {
    const leadForm = document.getElementById('lead_form_modal');

    this.element.addEventListener('click', () =>
      toggleClass('is-open', leadForm)
    );
  }
}
